var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('VueScroll',{ref:"vs",attrs:{"ops":_vm.ops}},[_c('RouterView')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }